import { CalendarClock, Edit3, Send, Trash2 } from 'lucide-react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

/**
 * Action row for a single scheduled message: edit text, change time, send now,
 * and delete (with confirmations). Shared by the side panel and inline thread.
 */
const ScheduledMessageActions = ({
  scheduledMessage,
  dialogs,
  onSendNow,
  onDelete,
  isActionLoading,
  className,
}) => (
  <div
    className={
      className || 'flex flex-wrap items-center gap-0.5 border-t border-border/60 px-1.5 py-1'
    }
  >
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-8 gap-1.5 px-2"
      onClick={() => dialogs.openEditDialog(scheduledMessage)}
      disabled={isActionLoading || dialogs.sendingBlocked || Boolean(scheduledMessage.textingBlocked)}
    >
      <Edit3 className="size-3.5" />
      Edit text
    </Button>
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-8 gap-1.5 px-2"
      onClick={() => dialogs.openRescheduleDialog(scheduledMessage)}
      disabled={isActionLoading || dialogs.sendingBlocked || Boolean(scheduledMessage.textingBlocked)}
    >
      <CalendarClock className="size-3.5" />
      Change time
    </Button>
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-8 gap-1.5 px-2"
          disabled={isActionLoading || dialogs.sendingBlocked || Boolean(scheduledMessage.textingBlocked)}
        >
          <Send className="size-3.5" />
          Send now
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="font-sans">
        <AlertDialogHeader>
          <AlertDialogTitle>Send this message now?</AlertDialogTitle>
          <AlertDialogDescription>
            Move to the top of the queue, and send within the next 10 minutes.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep scheduled</AlertDialogCancel>
          <AlertDialogAction disabled={dialogs.sendingBlocked} onClick={() => onSendNow(scheduledMessage)}>
            Send now
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-8 gap-1.5 px-2 text-destructive hover:text-destructive"
          disabled={isActionLoading}
        >
          <Trash2 className="size-3.5" />
          Delete
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="font-sans">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this scheduled message?</AlertDialogTitle>
          <AlertDialogDescription>
            This removes the scheduled message for this customer. The customer will not receive it.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            onClick={() => onDelete(scheduledMessage)}
          >
            Delete message
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </div>
);

export default ScheduledMessageActions;
